module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av432-b5bc54ee945b3639d099ae65ea1ad297.jpg";